import type { SVGProps } from 'react';
export const Folder = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M4.35 5.82v8.36h11.3V7.35h-5.47q-.4 0-.72-.23l-1.8-1.3zm-1-.98c.23-.22.54-.34.85-.34h3.52q.38 0 .71.23l1.8 1.3h5.57q.48 0 .85.34.34.35.35.83v7.19q0 .46-.34.79-.33.31-.8.32H4.2c-.31 0-.62-.12-.85-.34a1.2 1.2 0 0 1-.35-.83V5.67q.01-.48.35-.83"
      clipRule="evenodd"
    />
  </svg>
);
